module.exports = __webpack_public_path__ + "img/background.6df7b0ff.png";